import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import {htmlParam} from "../../../lib/utils";
import {Dummy} from '../';
import styles from './style.css';

export class Electrotable extends Dummy {

    render() {
        return (
            <div className={classNames('col-md-5', styles.electro)}>
                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.tgF6ar} colSpan="7">Мгновенные показатели:</th>
                    </tr>
                    <tr>
                        <th className={styles.tgF6ar}/>
                        <th className={styles.tgF6ar} colSpan="3">Ввод №1</th>
                        <th className={styles.tgF6ar} colSpan="3">Ввод №2</th>
                    </tr>
                    <tr>
                        <th className={styles.tgF6ar}/>
                        <th className={styles.tgF6ar}>А</th>
                        <th className={styles.tgF6ar}>В</th>
                        <th className={styles.tgF6ar}>С</th>
                        <th className={styles.tgF6ar}>А</th>
                        <th className={styles.tgF6ar}>В</th>
                        <th className={styles.tgF6ar}>С</th>
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Актив.мощн.(кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_101'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_102'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_103'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_101'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_102'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_103'], 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Реакт.мощн.(кВар)</td>
                        {htmlParam(this.props.params['ti_8_92_121'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_122'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_123'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_121'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_122'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_123'], 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Коэфф.мощности</td>
                        {htmlParam(this.props.params['ti_8_92_161'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_162'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_92_163'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_161'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_162'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_163'], 'td', styles.disabled, styles.value)}
                    </tr>

                    </tbody>
                </table>

                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.tgF6ar} colSpan="4">Накопленные показатели:</th>
                    </tr>
                    <tr>
                        <th className={styles.tgF6ar}/>
                        <th className={styles.tgF6ar}>Ввод №1</th>
                        <th className={styles.tgF6ar}>Ввод №2</th>
                        <th className={styles.tgF6ar}>Суммарная</th>

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_1'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_1'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_95_1'], 'td', styles.disabled, styles.value)}

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т1 Активная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_2'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_2'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_95_2'], 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т2 Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_3'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_3'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_95_3'], 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т3 Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_4'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_4'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_95_4'], 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Реакт. (кВар*ч)</td>
                        {htmlParam(this.props.params['ti_8_92_21'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_93_21'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_95_21'], 'td', styles.disabled, styles.value)}
                    </tr>
                    </tbody>
                </table>

                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.tgF6ar} colSpan="3">Накопленные показания электроэнергии:</th>
                    </tr>
                    <tr>
                        <th className={styles.tgF6ar}/>
                        <th className={styles.tgF6ar}>За сутки</th>
                        <th className={styles.tgF6ar}>За 10 дней</th>

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_126_11'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_126_24'], 'td', styles.disabled, styles.value)}

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т1 Активная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_126_14'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_126_31'], 'td', styles.disabled, styles.value)}

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т2 Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_126_15'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_126_32'], 'td', styles.disabled, styles.value)}

                    </tr>
                    <tr>
                        <td className={styles.tgF6ar}>Т3 Активаная (кВт*ч)</td>
                        {htmlParam(this.props.params['ti_8_126_16'], 'td', styles.disabled, styles.value)}
                        {htmlParam(this.props.params['ti_8_126_33'], 'td', styles.disabled, styles.value)}

                    </tr>
                    </tbody>
                </table>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Electrotable);



// WEBPACK FOOTER //
// ./src/components/entries/Electrotable/index.jsx